import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const card = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08 } }),
};

export const Incentives = () => {
  const { t } = useLang();
  const INCENTIVES = t.incentives;
  return (
    <section id="incentives" className="relative py-24 sm:py-32 bg-[var(--page)] text-[var(--ink)] border-t border-[var(--hairline)]" data-testid="incentives-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--ink)]" />
            <span className="text-[11px] sm:text-xs uppercase tracking-[0.25em] text-[var(--muted-ink)] font-semibold">
              {INCENTIVES.overline}
            </span>
          </div>
          <h2 className="font-display font-semibold tracking-tight leading-[1.03] text-3xl sm:text-4xl lg:text-5xl">
            {INCENTIVES.title}
          </h2>
          <p className="mt-5 text-xs uppercase tracking-[0.2em] text-[var(--muted-ink)] font-semibold">{INCENTIVES.reviewed}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 border-t border-l border-[var(--hairline)]">
          {INCENTIVES.items.map((it, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              variants={card}
              data-testid={`incentive-card-${i}`}
              className="p-8 sm:p-10 border-r border-b border-[var(--hairline)]"
            >
              <span className="font-display text-[var(--muted-ink)] text-2xl leading-none">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-6 font-display text-xl sm:text-2xl leading-tight">{it.t}</h3>
              <p className="mt-4 text-base text-[var(--muted-ink)] leading-relaxed">{it.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
